import { MonitorPlay, Users, MousePointerClick, BadgeDollarSign } from "lucide-react";
import { Reveal, SectionHeader } from "../Reveal";

const CARDS = [
    {
        icon: MonitorPlay,
        title: "WHAT WE DO",
        text: "WealthHaus Media is a professional digital billboard and advertising media company helping businesses promote their brands through digital billboard advertising, indoor digital displays, retail screens, rideshare screens, grocery and store displays, hotel displays, office building displays, airport displays, mall displays, transit advertising, and more.",
    },
    {
        icon: Users,
        title: "WHO WE SERVE",
        text: "Businesses launching a brand, promoting an event, introducing a product, increasing local awareness, or building long-term visibility — from a single local screen to multi-location campaigns.",
    },
    {
        icon: MousePointerClick,
        title: "HOW IT WORKS",
        text: "You select your advertising formats, markets, campaign duration, schedule, and number of billboards or screens based on available advertising inventory. We handle setup, monitoring, and the artwork approval process.",
    },
    {
        icon: BadgeDollarSign,
        title: "WHY WE'RE DIFFERENT",
        text: "Transparent per-billboard pricing starting at $60, campaigns from 2 days to custom extended runs, 13+ digital advertising formats, and an optional professional design service — all reviewed and approved before anything goes live.",
    },
];

export const FunnelSolution = () => (
    <section id="solution" className="relative bg-noir py-24 sm:py-32 overflow-hidden" data-testid="funnel-solution">
        <div className="absolute inset-0 led-dots opacity-40" aria-hidden="true" />
        <div className="absolute top-0 right-0 h-[380px] w-[380px] rounded-full bg-hotpink/10 blur-[120px]" aria-hidden="true" />
        <div className="relative mx-auto max-w-[1400px] px-4 sm:px-6">
            <SectionHeader
                eyebrow="THE WEALTHHAUS MEDIA SOLUTION"
                title={<>MORE THAN ADS. <span className="text-hotpink led-text-glow">WE BUILD BRANDS.</span></>}
                sub="We help businesses put their brand in the spotlight through strategic digital advertising opportunities across participating advertising and display networks."
            />
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {CARDS.map((c, i) => (
                    <Reveal key={c.title} delay={i * 0.08} className="h-full">
                        <div className="glass-panel h-full p-7 transition-all duration-300 hover:border-hotpink/50 hover:shadow-[0_0_36px_rgba(255,255,255,0.1)]" data-testid={`solution-card-${i}`}>
                            <c.icon size={26} className="text-hotpink" />
                            <h3 className="mt-4 font-alt text-[13px] font-bold tracking-[0.18em] text-white">{c.title}</h3>
                            <p className="mt-3 text-[13px] leading-relaxed text-zinc-400">{c.text}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
